export function detectDevice() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
    return 'Mobile';
  }
  return 'PC';
}



// WEBPACK FOOTER //
// ./src/utils/detectDevice.js